import React from 'react'; 
import SelectOrTransfer from '../../selectOrTransfer/SelectOrTransfer';

const LanguageSelectorSimple = ( { value, onChange, showSearch = true, languageOptions, 
    ...otherProps } ) => {

    return (
        <SelectOrTransfer
            mode={ 'select' }
            enabled= { ( languageOptions ) }
            dataSource={ languageOptions  }
            value={ value }
            onChange={ onChange }
            showSearch={ showSearch }
            { ...otherProps }
        />
    );
};

export default LanguageSelectorSimple;
